import type { Rarity, SpeciesDefinition } from './contracts'

export const SPECIES: SpeciesDefinition[] = [
  {
    id: 'glow-guppy',
    name: 'Glow Guppy',
    rarity: 'common',
    behavior: 'Early momentum',
    insight: 'Small moves can gather strength when each new price holds above the last.',
    color: 'cyan',
  },
  {
    id: 'coral-crab',
    name: 'Coral Crab',
    rarity: 'common',
    behavior: 'Range support',
    insight: 'Range edges matter most after price rejects them more than once.',
    color: 'coral',
  },
  {
    id: 'lantern-sprat',
    name: 'Lantern Sprat',
    rarity: 'common',
    behavior: 'Quiet liquidity',
    insight: 'Low volatility is stored energy, not a promise that price will stay still.',
    color: 'sea-glass',
  },
  {
    id: 'range-ray',
    name: 'Range Ray',
    rarity: 'rare',
    behavior: 'Consolidation',
    insight: 'A tight range rewards patience until price proves which edge can hold.',
    color: 'indigo',
  },
  {
    id: 'current-manta',
    name: 'Current Manta',
    rarity: 'rare',
    behavior: 'Trend continuation',
    insight: 'A trend stays healthy while pullbacks remain smaller than the impulse moves.',
    color: 'cyan',
  },
  {
    id: 'mean-revert-turtle',
    name: 'Mean-Revert Turtle',
    rarity: 'rare',
    behavior: 'Mean reversion',
    insight: 'An extended move can return toward its recent average without reversing the larger trend.',
    color: 'sea-glass',
  },
  {
    id: 'volatility-jelly',
    name: 'Volatility Jelly',
    rarity: 'rare',
    behavior: 'Volatility expansion',
    insight: 'Wider swings require wider targets and smaller risk, not faster guessing.',
    color: 'lime',
  },
  {
    id: 'abyss-eel',
    name: 'Abyss Eel',
    rarity: 'epic',
    behavior: 'False breakout',
    insight: 'A breakout that cannot hold beyond the range often snaps back quickly.',
    color: 'coral',
  },
  {
    id: 'breakout-barracuda',
    name: 'Breakout Barracuda',
    rarity: 'epic',
    behavior: 'Confirmed breakout',
    insight: 'Breakouts are stronger when price expands with speed and holds the former boundary.',
    color: 'lime',
  },
  {
    id: 'liquidity-squid',
    name: 'Liquidity Squid',
    rarity: 'epic',
    behavior: 'Liquidity sweep',
    insight: 'A fast wick through a known level can clear orders before price chooses direction.',
    color: 'coral',
  },
  {
    id: 'trendfin-tuna',
    name: 'Trendfin Tuna',
    rarity: 'epic',
    behavior: 'Sustained trend',
    insight: 'Consistent higher lows or lower highs reveal structure before indicators do.',
    color: 'cyan',
  },
  {
    id: 'frenzy-shark',
    name: 'Frenzy Shark',
    rarity: 'legendary',
    behavior: 'High-conviction momentum',
    insight: 'Conviction comes from repeated evidence, not from increasing the size of a guess.',
    color: 'lime',
  },
  {
    id: 'abyss-whale',
    name: 'Abyss Whale',
    rarity: 'legendary',
    behavior: 'Market liquidity',
    insight: 'Large liquidity zones can absorb price before the market reveals its next direction.',
    color: 'indigo',
    boss: true,
  },
]

export const SPECIES_BY_ID = Object.fromEntries(SPECIES.map((species) => [species.id, species]))

export const RARITY_ORDER: Record<Rarity, number> = {
  common: 0,
  rare: 1,
  epic: 2,
  legendary: 3,
}
